module.exports = {
    en: {},
    zn: {
        header: {
            title: '趣推吧后台'
        },
        sidebar: {
            GlobalSettingType: '全局配置',
            GlobalSetting: '全局配置',
            Package: '包管理',
            Version: '版本管理',
            Cdn: 'CDN',
            Domain: '收徒域名管理',
            Upload: '图片上传',
            ContentManage: '内容管理',
            NetworkArticleAudit: '网络图文审核',
            NetworkArticleAuditDetail: '网络图文详情',
            NetworkMediaAudit: '网络视频审核',
            NetworkMediaAuditDetail: '网络视频详情',
            PushContentManage: '线上内容管理',
            PushContentEdit: '线上内容编辑',
            Comment: '评论安全巡查',
            ArticlePush: '文章推送管理',
            ArticlePushEdit: '文章推送编辑',
            OperationManage: '用户管理',
            User: '用户管理',
            Tool: '工具',
            PushMessage: '系统消息',
            FinanceManage: '财务管理',
            ToReview: '提现审核',
            RateChange: '汇率调整',
            taskManage: '任务管理'
        }
    }
};
